import React from "react"

import {
  RoomTitle,
  RoomTitleProps
} from "entities/rooms/ui/room-title/RoomTitle"
import { PRODUCT_POSITION_TABLE_NAME_HEADER_ID } from "widgets/product-position-table/ProductPositionTableHeader"

import { ProductPositionTableCell } from "../../ProductPositionTableCell"
import { ProductPositionRowCellProps } from "../product-position/ProductPositionTableProductPositionRowView"

interface ProductPositionTableRoomRowTitleCellProps
  extends ProductPositionRowCellProps {
  room: RoomTitleProps["room"]
}

export const ProductPositionTableRoomRowTitleCell = React.memo(
  React.forwardRef(
    (
      { room, ...rest }: ProductPositionTableRoomRowTitleCellProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => {
      return (
        <ProductPositionTableCell
          ref={ref}
          title={room.label || undefined}
          className="project-table-row__room-title"
          data-testid="project-table__room-title-cell"
          aria-labelledby={PRODUCT_POSITION_TABLE_NAME_HEADER_ID}
          {...rest}
        >
          <div className="table-row-cell__content">
            <RoomTitle room={room} />
          </div>
        </ProductPositionTableCell>
      )
    }
  )
)
